<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import StepProgress from "@/components/widgets/StepProgress";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import appConfig from "@/app.config";
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";
import ModalImagePreview from "./ModalImagePreview.vue";
import ModalSoalPreview from "./ModalSoalPreview.vue";
import router from "../../../..";

export default {
  page: {
    title: "Soal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    StepProgress,
    ModalImagePreview,
    ModalSoalPreview,
  },
  computed: {
    tipeNormalized() {
      return this.previewDataSoal?.tipe?.toLowerCase() || "";
    },

    isObjectiveType() {
      return ["pilihan ganda", "benar salah"].includes(this.tipeNormalized);
    },

    isMatchingType() {
      return this.tipeNormalized === "menjodohkan";
    },

    isEssayType() {
      return ["text", "essay", "essai"].includes(this.tipeNormalized);
    },

    isCanSubmit() {
      return (
        this.isWrite === 1 &&
        !this.isValidator &&
        ["DRAFT", "REVISI"].includes(this.kompetensi.status_verifikasi)
      );
    },

    hasUnresolvedRevisi() {
      return this.table_data.some(
        (row) => row.active_flag && row.status_soal === "REVISI",
      );
    },

    isCanManageSoal() {
      return (
        this.isWrite === 1 &&
        !this.isValidator &&
        this.kompetensi.status_verifikasi === "DRAFT"
      );
    },
    isCanImportSoal() {
      return this.isWrite === 1 && !this.isValidator;
    },
    detectedLevel() {
      if (this.$route.query.level) return this.$route.query.level;
      if (this.kompetensi?.idlevel_kompetensi) return this.kompetensi.idlevel_kompetensi;
      if (this.kompetensi?.level_kompetensi?.idlevel_kompetensi) return this.kompetensi.level_kompetensi.idlevel_kompetensi;
      const nama = this.kompetensi?.level_kompetensi?.nama_level || "";
      const match = nama.match(/\d+/);
      return match ? match[0] : null;
    },
    isLevel4() {
      return (
        this.$route.query.level == 4 ||
        this.tableFilter.level == 4 ||
        this.detectedLevel == 4 ||
        this.kompetensi?.idlevel_kompetensi == 4 ||
        this.kompetensi?.level_kompetensi?.idlevel_kompetensi == 4 ||
        (this.kompetensi?.level_kompetensi?.nama_level &&
          this.kompetensi.level_kompetensi.nama_level.includes("4"))
      );
    },
    isLevel3() {
      return (
        this.$route.query.level == 3 ||
        this.tableFilter.level == 3 ||
        this.detectedLevel == 3 ||
        this.kompetensi?.idlevel_kompetensi == 3 ||
        this.kompetensi?.level_kompetensi?.idlevel_kompetensi == 3 ||
        (this.kompetensi?.level_kompetensi?.nama_level &&
          this.kompetensi.level_kompetensi.nama_level.includes("3"))
      );
    },
    columns() {
      let columns = [
        // { width: "50px", label: "", name: "-" },
        { width: "50px", label: "No", name: "-" },
        { width: "100px", label: "Nomor Soal", name: "-" },
        { width: "auto", label: "Tipe", name: "-" },
        { width: "auto", label: "Studi Kasus", name: "-" },
        { width: "auto", label: "Soal Gambar", name: "pertanyaan" },
        { width: "auto", label: "Pertanyaan", name: "-" },
        {
          width: "auto",
          label: this.isLevel4 ? "Jumlah Kunci Jawaban" : "Jumlah Jawaban",
          name: "-",
        },
        { width: "auto", label: "Status", name: "-" },
        { width: "270px", label: "Aksi", name: "-" },
      ];

      if (this.isValidator) {
        columns.splice(8, 0, {
          width: "auto",
          label: "Status Validator",
          name: "-",
        });
      }

      if (this.isCanManageSoal) {
        columns.unshift({ width: "50px", label: "", name: "-" });
      }
      return columns;
    },
    sortOrders() {
      let sortOrders = [];

      this.columns.forEach((column) => {
        sortOrders[column.name] = -1;
      });
      return sortOrders;
    },
  },
  watch: {
    "$route.query.level"(newLevel) {
      if (newLevel) {
        this.tableFilter.level = newLevel;
      } else {
        delete this.tableFilter.level;
      }
      this.getData();
    },
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      // { width: "50px", label: "", name: "-" },
      { width: "50px", label: "No", name: "-" },
      { width: "100px", label: "Nomor Soal", name: "-" },
      { width: "auto", label: "Tipe", name: "-" },
      { width: "auto", label: "Studi Kasus", name: "-" },
      { width: "auto", label: "Soal Gambar", name: "-" },
      { width: "auto", label: "Pertanyaan", name: "pertanyaan" },
      { width: "auto", label: "Jumlah Jawaban", name: "-" },
      { width: "auto", label: "Status", name: "-" },
      { width: "270px", label: "Aksi", name: "-" },
    ];

    if (this.isCanManageSoal) {
      columns.unshift({ width: "50px", label: "", name: "-" });
    }

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      isWrite: 1,
      isRead: 1,
      title: "Soal",
      link: process.env.VUE_APP_BACKEND_URL,
      isLoading: true,
      table_data: [],
      // columns: columns,
      sortKey: "kompetensi_idkompetensi",
      // sortOrders: sortOrders,

      currentTablePage: "",
      tableFilter: {
        status: 1,
        search: "",
        page: 1,
        per_page: 10,
        type_soal: "",
        ...(this.$route.query.level ? { level: this.$route.query.level } : {}),
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      idKompetensi: this.$route.params.id,
      kompetensi: {},
      modalImport: false,
      importFile: null,
      showModalImagePreview: false,
      showModalSoalPreview: false,
      previewUrl: "",
      previewDataSoal: null,
      listSoalDitandai: [],
      isValidator: localStorage.is_validator === "true",
      searchDebounced: () => {},
    };
  },
  mounted() {
    this.getKompetensi();
    this.getData();
    this.searchDebounced = _.debounce(() => this.getData(), 500);
    if (this.isValidator) {
      // Memasukkan objek baru di indeks ke-8 (tepat setelah 'Status')
      // this.columns.splice(8, 0, {
      //   width: "auto",
      //   label: "Status Validator",
      //   name: "-",
      // });
    }
  },
  methods: {
    async getKompetensi() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-level/" +
          this.idKompetensi,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          Accept: `Application/json`,
        },
      }).then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
        console.log({ kompetensi: this.kompetensi });
      }
    },
    async getData(resetPage = true) {
      if (resetPage) {
        this.tableFilter.page = 1;
      }
      this.isLoading = true;
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-level/" +
          this.idKompetensi +
          "/soal",
        params: this.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data_fix.data;
            this.configPagination(response_data_fix);
            this.currentTablePage = response_data_fix.current_page;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    previewImage(url) {
      this.previewUrl = url;
      this.showModalImagePreview = true;
    },
    async previewSoal(id) {
      try {
        Swal.showLoading();
        const res = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "verifikasi/kompetensi-level/" +
            this.idKompetensi +
            "/soal/" +
            id,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });
        Swal.close();

        this.previewDataSoal = res.data.data;
        // this.previewDataSoal.tipe = "menjodohkan";
        this.showModalSoalPreview = true;
      } catch (err) {
        console.error(err);
      }
    },

    getImageUrl(path) {
      return this.link + path;
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getData();
    },

    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getData(false);
    },

    isDetailDisabled(row) {
      const statusVerif = this.kompetensi.status_verifikasi;
      const statusSoal = row.status_soal;

      if (this.isValidator) {
        const allowedVerif = ["PENDING", "KOREKSI", "REVISI"];
        const allowedSoal = ["PENDING", "REVISI", "KOREKSI"];

        return !(
          allowedVerif.includes(statusVerif) && allowedSoal.includes(statusSoal)
        );
      }

      const allowedVerif = ["DRAFT", "REVISI"];
      const allowedSoal = ["REVISI", "DRAFT"];

      return !(
        allowedVerif.includes(statusVerif) && allowedSoal.includes(statusSoal)
      );
    },

    detailSoal(idverif_soal) {
      router.push({
        name: "edit-verif-soal",
        params: {
          id: this.idKompetensi,
          idSoal: idverif_soal,
        },
      });
    },

    async deleteData(row) {
      const result = await Swal.fire({
        title: "Apakah Anda yakin?",
        text: `Data soal akan dihapus permanen.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Sedang memproses data...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          await axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/${row.idverif_soal}`,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Status data berhasil hapus.",
            timer: 1500,
            showConfirmButton: false,
          });
          this.getData();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              error.response?.data?.meta?.message ||
              "Terjadi kesalahan saat menghapus data.",
          });
        }
      }
    },

    async deleteMultiple(restore = false) {
      if (!this.listSoalDitandai.length) return;

      const transaction = restore
        ? "memulihkan"
        : this.tableFilter.status == 1
        ? "menonaktifkan"
        : "menghapus permanen";
      const result = await Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: `Apakah Anda yakin ingin ${transaction} ${this.listSoalDitandai.length} data soal yang ditandai?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Iya",
        denyButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        Swal.fire({
          icon: "warning",
          iconHtml: '<i class="fas fa-spinner fa-spin"></i>',
          title: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        const method =
          restore || this.tableFilter.status == 1 ? "put" : "delete";
        const status = restore ? 1 : 0;

        try {
          await axios({
            method: method,
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal`,
            data: {
              ids: this.listSoalDitandai,
              status: status,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              Accept: "Application/json",
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data berhasil diproses.",
            timer: 2000,
            showConfirmButton: false,
          });

          this.listSoalDitandai = [];
          this.getData();
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response?.data?.meta?.message || "Gagal memproses data.",
          });
        }
      }
    },

    async deleteAll() {
      const action = "menghapus";
      const result = await Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: `Apakah Anda yakin ingin ${action} SEMUA data soal pada level kompetensi ini?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Iya",
        denyButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        Swal.fire({
          icon: "warning",
          iconHtml: '<i class="fas fa-spinner fa-spin"></i>',
          title: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        try {
          await axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/all`,
            data: {
              active_flag: this.tableFilter.status,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              Accept: "Application/json",
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Semua data berhasil diproses.",
            timer: 2000,
            showConfirmButton: false,
          });

          this.listSoalDitandai = [];
          this.getData();
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response?.data?.meta?.message || "Gagal memproses data.",
          });
        }
      }
    },

    async changeStatus(row) {
      const action = row.active_flag == 1 ? "nonaktifkan" : "aktifkan";
      const result = await Swal.fire({
        title: "Apakah Anda yakin?",
        text: `Data soal akan di-${action}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Sedang memproses data...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          await axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/${row.idverif_soal}/status`,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Status data berhasil diubah.",
            timer: 1500,
            showConfirmButton: false,
          });
          this.getData();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              error.response?.data?.meta?.message ||
              "Terjadi kesalahan saat mengubah status.",
          });
        }
      }
    },

    async changeStatusMultiple() {
      if (!this.listSoalDitandai.length) return;

      const transaction =
        this.tableFilter.status == 1 ? "menonaktifkan" : "memulihkan";
      const result = await Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: `Apakah Anda yakin ingin ${transaction} ${this.listSoalDitandai.length} data soal yang ditandai?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Iya",
        denyButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        Swal.fire({
          icon: "warning",
          iconHtml: '<i class="fas fa-spinner fa-spin"></i>',
          title: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        const method = "put";

        try {
          await axios({
            method: method,
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/status`,
            data: {
              ids: this.listSoalDitandai,
              active_flag: this.tableFilter.status,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              Accept: "Application/json",
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data berhasil diproses.",
            timer: 2000,
            showConfirmButton: false,
          });

          this.listSoalDitandai = [];
          this.getData();
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response?.data?.meta?.message || "Gagal memproses data.",
          });
        }
      }
    },

    async changeStatusAll() {
      const action =
        this.tableFilter.status == 1 ? "menonaktifkan" : "menghapus";
      const result = await Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: `Apakah Anda yakin ingin ${action} SEMUA data soal pada level kompetensi ini?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Iya",
        denyButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        Swal.fire({
          icon: "warning",
          iconHtml: '<i class="fas fa-spinner fa-spin"></i>',
          title: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        try {
          await axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `verifikasi/kompetensi-level/${this.idKompetensi}/soal/status/all`,
            data: {
              active_flag: this.tableFilter.status,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              Accept: "Application/json",
            },
          });

          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Semua data berhasil diproses.",
            timer: 2000,
            showConfirmButton: false,
          });

          this.listSoalDitandai = [];
          this.getData();
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response?.data?.meta?.message || "Gagal memproses data.",
          });
        }
      }
    },

    async submitValidation() {
      if (this.hasUnresolvedRevisi) {
        Swal.fire({
          icon: "warning",
          title: "Masih Ada Soal Revisi",
          text: "Selesaikan perbaikan semua soal berstatus REVISI terlebih dahulu sebelum mengajukan validasi kembali.",
        });
        return;
      }

      const result = await Swal.fire({
        icon: "question",
        title: "Ajukan Validasi Soal?",
        text: "Semua soal pada kompetensi ini akan diajukan ke validator. Pastikan data sudah lengkap dan benar.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Ya, Ajukan",
        denyButtonText: "Batal",
      });

      if (!result.isConfirmed) return;

      // loading state
      Swal.fire({
        title: "Memproses...",
        text: "Sedang mengajukan soal ke validator",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await axios({
          method: "post",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            `verifikasi/kompetensi-level/${this.idKompetensi}/soal/submit`,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        // success
        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Soal berhasil diajukan untuk divalidasi",
          timer: 1500,
          showConfirmButton: false,
        });

        // optional: refresh data / update UI
        this.getData();
        this.getKompetensi();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text:
            error.response?.data?.meta?.message ||
            "Terjadi kesalahan saat mengajukan validasi.",
        });
      }
    },

    exportExcel() {
      const level =
        this.$route.query.level ||
        this.kompetensi?.idlevel_kompetensi ||
        this.kompetensi?.level?.idlevel ||
        "";
      const levelParam = level ? `?level=${level}` : "";
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/kompetensi-level/" +
          this.idKompetensi +
          levelParam,
      );
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title">Soal</div>
                  <div>
                    <span class="font-weight-bold">Kode Kompetensi :</span>
                    <br />
                    <strong>{{
                      kompetensi?.kompetensi?.kode_kompetensi || "-"
                    }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{
                      kompetensi?.kompetensi?.nama_kompetensi || "-"
                    }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2">
                  <router-link
                    class="btn btn-secondary btn-sm"
                    :to="{ name: 'all-kompetensi-level' }"
                  >
                    <i class="fa fa-arrow-left me-1"></i> Kembali
                  </router-link>
                  <button
                    class="btn btn-warning btn-sm"
                    @click="submitValidation"
                    v-if="isCanSubmit"
                    :disabled="table_data.length == 0 || hasUnresolvedRevisi"
                    :title="
                      hasUnresolvedRevisi
                        ? 'Masih ada soal berstatus REVISI yang belum diperbaiki'
                        : ''
                    "
                  >
                    <i class="fa fa-paper-plane me-1"></i>
                    Ajukan Validasi
                  </button>
                  <router-link
                    :to="{
                      name: 'import-verif-soal',
                      query: detectedLevel
                        ? { level: detectedLevel }
                        : ($route.query.level ? { level: $route.query.level } : {}),
                    }"
                    class="btn btn-success btn-sm"
                    v-if="isCanImportSoal"
                  >
                    <i class="fa fa-file-excel me-1"></i>
                    Import Soal Kompetensi
                  </router-link>
                  <button class="btn btn-success btn-sm" @click="exportExcel">
                     <i class="fa fa-file-excel me-1"></i>
                     Export Soal Kompetensi
                  </button>
                  <router-link
                    class="btn btn-primary btn-sm"
                    :to="{
                      name: 'tambah-verif-soal',
                      query: detectedLevel
                        ? { level: detectedLevel }
                        : ($route.query.level ? { level: $route.query.level } : {}),
                    }"
                    v-if="isCanManageSoal"
                  >
                    <i class="fa fa-plus me-1"></i>
                    Tambah
                  </router-link>
                </div>
              </div>
              <div class="col-12">
                <hr />
                <StepProgress :currentStatus="kompetensi.status_verifikasi" />
              </div>
              <div class="col-12">
                <hr />
                <div class="row mb-2">
                  <div class="form-group col-md-2">
                    <label for="statusTable">Status</label>
                    <select
                      class="form-select"
                      id="statusTable"
                      v-model="tableFilter.status"
                      @change="
                        getData();
                        listSoalDitandai = [];
                      "
                    >
                      <option value="1">ENABLE</option>
                      <option value="0">DISABLE</option>
                    </select>
                  </div>
                </div>
                <hr />
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mb-1">
              <button
                class="btn btn-warning btn-sm"
                :disabled="!listSoalDitandai.length"
                @click="changeStatusMultiple()"
                v-if="isCanManageSoal"
              >
                <span v-if="tableFilter.status == 1">
                  <i class="fa fa-trash me-1"></i>
                  Disable Soal Ditandai
                </span>
                <span v-else>
                  <i class="fa fa-recycle me-1"></i> Restore Soal Ditandai
                </span>
              </button>
              <button
                class="btn btn-warning btn-sm"
                @click="changeStatusAll()"
                v-if="isCanManageSoal"
              >
                <span v-if="tableFilter.status == 1">
                  <i class="fa fa-trash me-1"></i>
                  Disable Semua Soal
                </span>
                <span v-else>
                  <i class="fa fa-recycle me-1"></i>
                  Restore Semua Soal Ditandai
                </span>
              </button>
              <button
                class="btn btn-danger btn-sm"
                :disabled="!listSoalDitandai.length"
                @click="deleteMultiple(false)"
                v-if="tableFilter.status == 0 && isCanManageSoal"
              >
                <i class="fa fa-trash me-1"></i>
                Hapus Soal Ditandai
              </button>
              <button
                class="btn btn-danger btn-sm"
                @click="deleteAll()"
                v-if="tableFilter.status == 0 && isCanManageSoal"
              >
                <i class="fa fa-trash me-1"></i>
                Hapus Semua Soal
              </button>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <div class="d-flex align-items-end">
                <table>
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <div style="max-width: 50%; width: 500px">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="searchTable"
                  placeholder="Cari Data ..."
                  v-model="tableFilter.search"
                  @input="searchDebounced()"
                />
              </div>
            </div>
            <div class="row">
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="isLoading">
                    <td class="text-center" colspan="99">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="table_data == ''">
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row_data, key_data) in table_data"
                    :key="key_data"
                  >
                    <td class="text-center" v-if="isCanManageSoal">
                      <input
                        type="checkbox"
                        class="largerCheckbox"
                        :value="row_data.idverif_soal"
                        v-model="listSoalDitandai"
                      />
                    </td>
                    <td>{{ key_data + pagination.from }}</td>
                    <td>{{ row_data.nomor_urut ?? "-" }}</td>
                    <td>{{ row_data.tipe }}</td>
                    <td>{{ row_data.studi_kasus || "-" }}</td>
                    <td>
                      <div
                        class="container-image"
                        v-if="row_data.pertanyaan_gambar"
                      >
                        <img
                          v-if="row_data.pertanyaan_gambar"
                          :src="link + row_data.pertanyaan_gambar"
                          class="image"
                        />
                        <div
                          class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                        >
                          <button
                            class="btn btn-success btn-sm"
                            @click="
                              previewImage(link + row_data.pertanyaan_gambar)
                            "
                          >
                            <i class="fa fa-search"></i> Preview
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>{{ row_data.pertanyaan }}</td>
                    <td class="text-center">
                      {{ isLevel4 ? (row_data.keyword_soal_count ?? row_data.jawaban_count ?? 0) : (row_data.jawaban_count ?? 0) }}
                    </td>
                    <td class="text-center">
                      <div class="d-flex flex-column align-items-center gap-1">
                        <!-- STATUS -->
                        <span
                          class="badge font-size-12"
                          :class="{
                            'bg-warning': ['DRAFT', 'KOREKSI'].includes(
                              row_data.status_soal,
                            ),
                            'bg-info': row_data.status_soal === 'PENDING',
                            'bg-danger': row_data.status_soal === 'REVISI',
                            'bg-success': row_data.status_soal === 'APPROVED',
                          }"
                        >
                          {{ row_data.status_soal }}
                        </span>

                        <!-- CATATAN -->
                        <!-- <span
                          v-if="row_data.catatan"
                          :id="'popover-target-' + key_data"
                          class="ms-1 text-warning cursor-pointer"
                          title="Catatan Validator"
                        >
                          <i class="fa fa-comment-dots fa-lg"></i>
                        </span> -->
                      </div>

                      <!-- <b-popover
                        v-if="row_data.catatan"
                        :target="'popover-target-' + key_data"
                        triggers="hover focus"
                        placement="top"
                      >
                        <template #title>Catatan Validator</template>
                        {{ row_data.catatan }}
                      </b-popover> -->
                    </td>
                    <td class="text-center" v-if="isValidator">
                      <div class="d-flex flex-column align-items-center gap-1">
                        <!-- STATUS -->
                        <span
                          class="badge font-size-12"
                          :class="{
                            'bg-warning': ['DRAFT', 'KOREKSI'].includes(
                              row_data.status_soal_validasi,
                            ),
                            'bg-info': row_data.status_soal_validasi === 'PENDING',
                            'bg-danger': row_data.status_soal_validasi === 'REVISI',
                            'bg-success': row_data.status_soal_validasi === 'APPROVED',
                          }"
                        >
                          {{ row_data.status_soal_validasi }}
                        </span>

                        <!-- CATATAN -->
                        <span
                          v-if="row_data.catatan_validator"
                          :id="'popover-target-' + key_data"
                          class="ms-1 text-warning cursor-pointer"
                          title="Catatan Validator"
                        >
                          <i class="fa fa-comment-dots fa-lg"></i>
                        </span>
                      </div>

                      <b-popover
                        v-if="row_data.catatan_validator"
                        :target="'popover-target-' + key_data"
                        triggers="hover focus"
                        placement="top"
                      >
                        <template #title>Catatan Validator</template>
                        {{ row_data.catatan_validator }}
                      </b-popover>
                    </td>
                    <td>
                      <div class="d-flex gap-1 justify-content-center">
                        <button
                          class="btn btn-info btn-sm"
                          @click="previewSoal(row_data.idverif_soal)"
                          v-if="row_data.active_flag"
                        >
                          <i class="fa fa-search me-1"></i> Preview
                        </button>
                        <template
                          v-if="
                            kompetensi.status_verifikasi !== 'APPROVED' &&
                            row_data.active_flag
                          "
                        >
                          <button
                            class="btn btn-primary btn-sm"
                            :disabled="isDetailDisabled(row_data)"
                            @click="detailSoal(row_data.idverif_soal)"
                          >
                            <i
                              :class="
                                isValidator
                                  ? 'fa fa-clipboard-check me-1'
                                  : isDetailDisabled(row_data)
                                  ? 'fa fa-lock me-1'
                                  : 'fa fa-edit me-1'
                              "
                            ></i>

                            <span v-if="isValidator">Validasi</span>
                            <span v-else-if="isDetailDisabled(row_data)">
                              Terkunci
                            </span>
                            <span v-else>Setup</span>
                          </button>
                        </template>
                        <button
                          class="btn btn-danger btn-sm"
                          v-if="
                            row_data.active_flag &&
                            !isValidator &&
                            kompetensi.status_verifikasi == 'DRAFT'
                          "
                          @click="changeStatus(row_data)"
                        >
                          <i class="fa fa-trash me-1"></i> Disable
                        </button>
                        <button
                          class="btn btn-warning btn-sm"
                          v-if="!row_data.active_flag && isCanManageSoal"
                          @click="changeStatus(row_data)"
                        >
                          <i class="fa fa-recycle me-1"></i> Enable
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          v-if="!row_data.active_flag && isCanManageSoal"
                          @click="deleteData(row_data)"
                        >
                          <i class="fa fa-trash me-1"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
            </div>

            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>

  <ModalImagePreview v-model="showModalImagePreview" :url="previewUrl" />

  <ModalSoalPreview
    v-model="showModalSoalPreview"
    :data="previewDataSoal"
    :link="link"
  />
</template>

<style scoped>
input.largerCheckbox {
  width: 20px;
  height: 20px;
}

.popover-catatan {
  max-width: 280px;
  border-radius: 10px;
  border: none;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.popover-catatan .popover-header {
  background: #fff3cd;
  color: #856404;
  font-size: 13px;
  border-bottom: 1px solid #ffeeba;
}

.popover-catatan .popover-body {
  font-size: 13px;
  line-height: 1.5;
  color: #444;
}

/* optional: kalau gambar gede banget (diagram) */
@media (min-width: 1200px) {
  .soal-image {
    max-height: 500px;
  }
}
</style>
